import { ApiErrorCode } from '@protots/api_error_code'

export const errorPredicates = (codes: ApiErrorCode[]) => ({
  isAutoCampaignDisabled: codes.includes(
    ApiErrorCode.PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION
  ),
  isTacShouldBeAccepted: codes.includes(ApiErrorCode.PC_TAC_SHOULD_BE_ACCEPTED),
  isCantAcceptNewMessages: codes.includes(
    ApiErrorCode.PC_CONVERSATION_CANT_ACCEPT_NEW_MESSAGES
  ),
})
